"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGISTRATION_STEP1 = 'registrationStep1';
exports.REGISTRATION_STEP2 = 'registrationStep2';
exports.LOGIN_PAGE = 'loginPage';
exports.REGISTRATION_PAGE = 'registrationPage';
